import React from 'react';
import styled from 'styled-components';
import * as Ant from 'antd';

export default function BadgeCard(props) {
  const {id, badge, setCardView} = props;
  return (
    <Wrapper id={id} badge={badge}>
      <div className="content">
        <img
          src={badge.customization?.card_image || '/images/site-logo.png'}
          alt="badge"
          className="card"
          onClick={() => setCardView(false)}
        />
        <Ant.Button
          size="large"
          onClick={() => setCardView(false)}
          style={{borderRadius: 100, marginTop: 20}}>
          更多資訊
        </Ant.Button>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  min-height: 100vh;
  top: 0;
  left: 0;
  background: ${(props) =>
    props.badge.customization?.card_background_css} || '#333'};
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > .content {
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;

    & > img.card {
      display: block;
      margin: 0 auto;
      width: 480px;
      height: 768px;
      border-radius: 20px;
      box-shadow: ${(props) =>
        props.badge.customization?.dark_card_background_css
          ? '0px 5px 30px rgba(255, 255, 255, 0.7)'
          : '0px 5px 30px rgba(0, 0, 0, 0.35)'};
      object-fit: cover;
      align-self: center;
      background-color: #ccc;
      cursor: pointer;
    }

    & > h1.name {
      color: white;
    }

    & > div.description {
      color: #888;
      max-width: 360px;
      text-align: center;
    }
  }

  @media (max-width: 1180px) {
    padding: 10px;

    & > .content {
      & > img.card {
        width: 350px;
        height: 560px;
      }
    }
  }
`;
